



























import { Component, Vue } from "vue-property-decorator";
import { Solution } from "@/services/solutions/types";

    @Component
export default class RemoveSolutionFromContractModal extends Vue {
    // local
    localSolution = {} as Solution;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
    }

    // methods
    open(item: Solution) {
        this.localSolution = item;
        this.$bvModal.show("modal-removeSolutionFromContract");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-removeSolutionFromContract");
    }

    confirm() {
        this.$emit("removeSolution", this.localSolution);
        this.$bvModal.hide("modal-removeSolutionFromContract");
    }
}
